import { emptyApplicationsFacets } from 'features/applications/applicationsSlice';

import { ApplicationElasticSearchFacets } from 'types/applications';
import { ElasticSearchFacetCounts } from 'types/commons';
import { JobseekerElasticSearchFacets } from 'types/jobseekers';

import { COUNTRIES_WITH_STATES } from './countriesData';
import { AppModules } from './enums';

// TODO: "None" means "All" values at the time, decision must be resolved within separate task
export const EXCLUDED_FACET_KEYS = ['None'];

export const SELECTED_FILTER_TAG_LABEL = {
  Skillset: 'filterTag.label.skillset',
  Education: 'filterTag.label.education',
  Languages: 'filterTag.label.languages',
  Citizenship: 'filterTag.label.citizenship',
  Country: 'filterTag.label.country',
  City: 'filterTag.label.city',
  State: 'filterTag.label.state'
} as const;

export const SELECTED_FILTER_TYPE = {
  Skillset: 'skillset',
  Country: 'country',
  Citizenship: 'citizenship',
  Education: 'education',
  Languages: 'languages',
  City: 'city',
  State: 'state'
} as const;

export const JOBSEEKERS_DEFAULT_FACETS_CONFIG: {
  key: keyof JobseekerElasticSearchFacets;
  field: string;
}[] = [
  { key: 'country', field: 'location.country.keyword' },
  { key: 'education', field: 'education' },
  { key: 'skillsets', field: 'skillsets.keyword' },
  { key: 'languages', field: 'languageCodes.keyword' },
  { key: 'citizenship', field: 'citizenship.keyword' },
  { key: 'stage', field: 'stage' }
];

export const JOBSEEKERS_ADDITIONAL_FACETS_CONFIG: {
  key: keyof JobseekerElasticSearchFacets;
  field: string;
}[] = [
  { key: 'state', field: 'location.state' }
  // TODO: Uncomment when city facets implemented
  // { key: 'city', field: 'location.city' }
];

export const JOBSEEKERS_FACET_FIELDS_BY_COUNTRY_CONFIG = {
  triggerCountryCodes: COUNTRIES_WITH_STATES,
  additionalFacetFields: JOBSEEKERS_ADDITIONAL_FACETS_CONFIG.map(
    ({ field }) => field
  )
};

export const APPLICATIONS_DEFAULT_FACETS_CONFIG: {
  key: keyof ApplicationElasticSearchFacets;
  field: string;
}[] = [
  { key: 'education', field: 'jobseekerEducation' },
  { key: 'languages', field: 'jobseekerLanguageCodes.keyword' },
  { key: 'countries', field: 'jobseekerLocation.country' },
  { key: 'skillsets', field: 'jobseekerSkills.raw' },
  // With current BE implementation, when we request 'stage', BE sends us both 'stage' and 'clientStage' facets
  { key: 'stage', field: 'stage' }
];

export const APPLICATIONS_ADDITIONAL_FACETS_CONFIG: {
  key: keyof ApplicationElasticSearchFacets;
  field: string;
}[] = [
  { key: 'clientStage', field: 'clientStage' },
  // We need this, as a workaround, since we request from BE jobseekerSkills.raw, and the prop which comes is named jobseekerSkills
  { key: 'skillsets', field: 'jobseekerSkills' }
];

// Default facetFields configuration per module
export const MODULE_DEFAULT_FACET_FIELDS: Partial<
  Record<AppModules, string[]>
> = {
  [AppModules.Jobseekers]: JOBSEEKERS_DEFAULT_FACETS_CONFIG.map(
    ({ field }) => field
  ),
  [AppModules.Applications]: APPLICATIONS_DEFAULT_FACETS_CONFIG.map(
    ({ field }) => field
  )
};

export const mapApplicationsFacetsForStore = (
  payload: Record<string, ElasticSearchFacetCounts | undefined> | undefined
): ApplicationElasticSearchFacets => {
  const facets: ApplicationElasticSearchFacets = { ...emptyApplicationsFacets };
  if (!payload) {
    return facets;
  }

  [
    ...APPLICATIONS_DEFAULT_FACETS_CONFIG,
    ...APPLICATIONS_ADDITIONAL_FACETS_CONFIG
  ].forEach(({ key, field }) => {
    facets[key] = payload[field] || {};
  });

  return facets;
};
